import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class ReferidoPromotionalCodeQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) {}

  async run(user_id:Number): Promise<any> {
    let args = { user_id: user_id }
    let data = await this.dispatcher.dispatch('promotional_code.data', args)
    if (data.status === '200') {
      this.frontend.assign_promotional_code(data.data)
    } else {
      return 'There is no active promotional codes for this user id'
    }
  }
}